import SimpleIntro from "../../components/General/SimpleIntro";
import AdvancedText from "../../components/General/AdvancedText";
import AdvancesCardList from "../../components/General/AdvancesCardList";
import AdvancedIntro from "../../components/General/AdvancedIntro";

const Vip = () => {
  return (
    <section>
      <SimpleIntro urlApi="services/vip/simpleIntro" />

      <div className="container text-center">
        <div style={{ margin: "7rem auto" }}>
          <AdvancedText urlApi="services/vip/advancedText" />

          <AdvancesCardList urlApi="services/vip/vipList" />
        </div>
      </div>

      <AdvancedIntro urlApi="services/vip/advancedIntro" />
    </section>
  );
};

export default Vip;
